import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Core Components
import { ShimmerRouterOutletComponent } from './components/shimmer-router-outlet/shimmer-router-outlet.component';
import { ShimmerComponent } from './components/shimmer/shimmer.component';

// Skeleton Components
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { DefaultShimmerComponent } from './components/skeletons/default-skeleton/default-shimmer.component';
import { StorefrontShimmerComponent } from './components/skeletons/storefront-skeleton/storefront-shimmer.component';
import { MyAhaShimmerComponent } from './components/skeletons/myaha-skeleton/myaha-shimmer.component';

// Services
import { ShimmerService } from './services/shimmer.service';

@NgModule({
  declarations: [
    // Core Components
    ShimmerComponent,
    ShimmerRouterOutletComponent,
    
    // Skeleton Components
    SkeletonComponent,
    DefaultShimmerComponent,
    StorefrontShimmerComponent,
    MyAhaShimmerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ],
  providers: [
    ShimmerService
  ],
  exports: [
    // Core Components
    ShimmerComponent,
    ShimmerRouterOutletComponent,
    
    // Skeleton Components
    SkeletonComponent,
    DefaultShimmerComponent,
    StorefrontShimmerComponent,
    MyAhaShimmerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShimmerModule {}
